module.exports = "/_next/static/assets/img/focus-b1c1ead9f9d68886d0cf68e8b82872f9.jpg";